import React, { useContext } from "react";
import "./Why_Ambassadeur.css";
import Pink_box from "../../../common_components/pink_box/Pink_box";
import Common_subHeading from "../../../common_components/common_subHeading/Common_subHeading";
import { Context } from "../../../../utils/context";

function Why_Ambassadeur({ data }) {


  const { language } = useContext(Context);


  return (
    <section className="Why_Ambassadeur">
      <div className="container">
         {/* <Common_subHeading subHeading="What You Get With AFI" /> */}

        <Common_subHeading subHeading={language == 1 ? "What You Get With AFI" : "Ce que vous obtenez avec AFI"} />

        <div className="pink_box_holder">
          <div className="row">
            {data?.length > 0 ? (
              data?.map((item, index) => (
                <div className="col-lg-4 col-md-4 col-sm-6 mb-4" key={index}>
                  <Pink_box box_text={item.WebWhatYouGet_Lang?.name} />
                </div>
              ))
            ) : (
              <div className="text-center">No Data Found</div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Why_Ambassadeur;
